import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TextCallout1, TextCallout2 } from 'blocket-ui'
import { withDevice } from '@blazar-plugins/device'

const Wrapper = styled.div`
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  position: relative;
`

// Hook
function useOnClickOutside(toolTipRef, handler) {
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!toolTipRef.current || toolTipRef.current.contains(event.target)) {
        return
      }

      handler(event)
    }
    document.addEventListener('mousedown', listener)
    document.addEventListener('mouseover', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('mouseover', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [toolTipRef, handler])
}

const ToolTip = ({
  title: Title,
  text: Text,
  tooltipIsOpen = false,
  children,
  device,
  className = '',
  ToolTipWrapper,
}) => {
  const toolTipRef = useRef(null)
  const [toolTipOpen, setToolTipOpen] = useState(tooltipIsOpen)
  const toggleToolTip = (e) => {
    e.stopPropagation()
    setToolTipOpen(!toolTipOpen)
  }

  useOnClickOutside(toolTipRef, () => setToolTipOpen(false))

  useEffect(() => {
    setToolTipOpen(tooltipIsOpen)
  }, [tooltipIsOpen])

  const isDesktop = device.is('medium') || device.is('large') || device.is('extraLarge')
  const isValidElement = (elm) => elm && typeof parm === 'function' && React.isValidElement(elm)

  return (
    <Wrapper
      className={className}
      onClick={toggleToolTip}
      onMouseEnter={isDesktop ? toggleToolTip : undefined}
      onMouseLeave={isDesktop ? toggleToolTip : undefined}
      ref={toolTipRef}
    >
      <ToolTipWrapper show={toolTipOpen}>
        {isValidElement(Title) ? <Title /> : <TextCallout1>{Title}</TextCallout1>}
        {isValidElement(Text) ? <Text /> : <TextCallout2>{Text}</TextCallout2>}
      </ToolTipWrapper>
      {children}
    </Wrapper>
  )
}

ToolTip.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  ToolTipWrapper: PropTypes.object,
  tooltipIsOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  device: PropTypes.shape({ is: PropTypes.func.isRequired }).isRequired,
}

export default withDevice(ToolTip)
